.fullWrap {
  min-height: 60vh;
  width: 100%;
}

.inlineWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.mark {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: light-dark(var(--mantine-color-laut-6), var(--mantine-color-laut-7));
  box-shadow: light-dark(0 8px 22px -6px rgba(14, 124, 123, 0.45), 0 8px 22px -6px rgba(5, 8, 12, 0.7));
  animation: roseSpin 8s linear infinite;
}

.markSm {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

@keyframes roseSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.label {
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: light-dark(var(--mantine-color-kertas-8), var(--mantine-color-dark-2));
}

@media (prefers-reduced-motion: reduce) {
  .mark {
    animation: none;
  }
}
